import { useMutation } from "@apollo/client/react";
import { Box, Icon, IconicButton } from "@nulogy/components";
import { GridBox7, StyledInput, StyledText } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import Form from "components/controls/Form";
import { insertLine } from "hooks/apollo/line/helpers/handleUpdateLines";
import { CreateLine } from "hooks/apollo/line/line.gql";
import React from "react";
import Num from "utils/Num";
import LineStatusSelect from "./LineStatusSelect";

export default function NewLine({ lineId, onRemoveNewLine }) {
  const [createLine] = useMutation(CreateLine);

  const handleSave = ({ id, name, lineType, efficiency, active }) => {
    const efficiencyDecimal = efficiency === "" ? null : Num.percentToDecimal(efficiency);

    return createLine({
      update: (proxy, { data }) => {
        const newLine = data.createLine.line;

        insertLine(newLine, proxy);
      },
      variables: { active, efficiency: efficiencyDecimal, id, lineType, name },
    });
  };

  const removeNewLine = () => {
    onRemoveNewLine(lineId);
  };

  return (
    <Form
      initialValues={{ active: true, efficiency: 100, id: lineId, lineType: "", name: "" }}
      onAfterSave={removeNewLine}
      onSave={handleSave}
    >
      {({ dirty }) => (
        <FieldRow data-testid="new-line-row" marginBottom="0">
          <GridBox7>
            <StyledText>
              <Icon color="darkBlue" icon="drag" style={{ opacity: 0.5 }} />
            </StyledText>
            <StyledInput field="name" placeholder="Name" />
            <StyledInput field="lineType" placeholder="Type" />
            <StyledInput
              field="efficiency"
              placeholder="Efficiency"
              step="any"
              style={{ width: "112px" }}
              type="number"
            />
            <LineStatusSelect />

            <Box paddingTop="x1">
              <IconicButton disabled={!dirty} icon="check" type="submit">
                Save
              </IconicButton>
            </Box>
            <Box paddingTop="x1">
              <IconicButton icon="close" onClick={removeNewLine} type="button">
                Cancel
              </IconicButton>
            </Box>
          </GridBox7>
        </FieldRow>
      )}
    </Form>
  );
}
